import prepareComponent from "@bluframe/grapple/prepareComponent"
import { useState } from "react"

import items, { Item } from "./items"
import Navigation from "./Navigation"

export interface Props {
  isAdmin: boolean
  isEditor: boolean
  isExpanded: boolean
  isSocials: boolean
  name: string
  onToggleIsExpanded: () => void
}

export interface ComponentProps extends Props {
  items: Item[]

  onSetOpenSubItems: (id: string | null) => () => void
  openSubItems: string | null
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const [openSubItems, setOpenSubItems] = useState<string | null>(null)

  const onSetOpenSubItems = (id: string | null) => () => {
    setOpenSubItems(id)
  }

  return {
    ...props,
    items,
    onSetOpenSubItems,
    openSubItems
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Navigation
)
